import { UserComponent } from '@craftjs/core';
import { FormFieldProps, FormFieldWithScoreProps } from './BaseControlTypes';
import { createId } from 'src/helpers/typeUtils';

export type FormNumberInputProps = FormFieldProps &
  FormFieldWithScoreProps & {
    placeholder?: string;
    units?: string;
    decimal?: number;
  };

export const formNumberInputDefaultProps: FormNumberInputProps = {
  dataKey: createId(),
  title: 'Form number input',
  placeholder: 'Enter number here',
};

export type FormNumberInputComponent = UserComponent<FormNumberInputProps>;
